module.exports = __webpack_public_path__ + "media/images/icons/bookmarks-e8874a02909531635d659ed4c101e6d7.svg";